import { Component } from 'react';

class AvgStarRating extends Component {
  render() {
    return (
      <div className="status-block">
        <div className="status-block__status spec-avg-star-rating">
          {this.props.value || 'N/A'}
        </div>
        <div className="status-block__title">{this.props.label}</div>
      </div>
    );
  }
}

export default AvgStarRating;
